<template>
  <div>
    <el-card style="margin-bottom: 10px;">
      <el-form :model="queryForm" label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="5">
            <!-- 保险公司名称 -->
            <el-form-item :label="$t('mdfeTranslate.InsuranceCompanyName')">
              <template slot="label">
                <el-select
                  v-model="queryForm.params.nameType"
                  :placeholder="$t('orderDetails.pleaseChoose')"
                  class="postcodeType-class"
                >
                  <!--保险公司名称-->
                  <el-option key="1" :label="$t('mdfeTranslate.InsuranceCompanyName')" :value="1" />
                  <!--配置名称-->
                  <el-option key="2" :label="$t('mdfeTranslate.ConfigurationName')" :value="2" />
                </el-select>
              </template>
              <el-input v-model="queryForm.params.name" :placeholder="$t('collectionCenter.pleaseInput')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 启用状态 -->
            <el-form-item :label="$t('GlobalSetObj.EnableStatus')">
              <el-select
                v-model="queryForm.params.state"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                style="width: 100%;"
              >
                <el-option :label="$t('collectionCenter.tudo')" :value="null" />
                <el-option :label="$t('collectionCenter.enable')" :value="1" />
                <el-option :label="$t('GlobalSetObj.disable')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <!-- 创建时间 -->
            <el-form-item :label="$t('collectionCenter.createTime')">
              <template slot="label">
                <el-select
                  v-model="queryForm.params.timeType"
                  :placeholder="$t('orderDetails.pleaseChoose')"
                  class="postcodeType-class"
                >
                  <!--创建时间-->
                  <el-option key="1" :label="$t('GlobalSetObj.CreationTime')" :value="1" />
                  <!--更新时间-->
                  <el-option key="2" :label="$t('GlobalSetObj.UpdateTime')" :value="2" />
                  <!--生效时间-->
                  <el-option key="3" :label="$t('customerManagements.genterTiem')" :value="3" />
                </el-select>
              </template>
              <el-date-picker
                v-model="dateTime"
                type="datetimerange"
                range-separator="-"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                :end-placeholder="$t('GlobalSetObj.endDate')"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 创建人 -->
            <el-form-item :label="$t('collectionCenter.creator')">
              <el-select
                v-model="queryForm.params.createUser"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                size="small"
                clearable
                filterable
                style="width: 95%"
                remote
                reserve-keyword
                :remote-method="getAllUser"
                @visible-change="openCreateUserSelect"
              >
                <el-option
                  v-for="(item, idx) in allUserList"
                  :key="idx"
                  :label="item.realName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div>
          <el-button type="primary" size="small" @click="queryTableData">
            {{ $t('newOrder.search') }}
          </el-button>
          <el-button size="small" @click="resetForm">{{ $t('collectionCenter.reset') }}</el-button>
        </div>
      </el-form>
    </el-card>
    <el-card>
      <div style="margin-bottom: 10px;">
        <el-button type="primary" size="small" @click="addConfiguration(1)">
          {{ $t('GlobalSetObj.create') }}
        </el-button>
      </div>
      <el-table
        :data="tableData"
        border
        :header-cell-style="{background: '#e1e1e1', color: '#000', 'font-size': '15px'}"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')" align="center" type="index"
          width="80"
        />
        <!-- 保险公司 -->
        <el-table-column
          :label="$t('mdfeTranslate.InsuranceCompany')" show-overflow-tooltip prop="name"
          min-width="180"
        />
        <!--cnpj-->
        <el-table-column
          label="CNPJ" prop="cnpj" min-width="180"
          show-overflow-tooltip
        />
        <!--保单号-->
        <el-table-column
          :label="$t('mdfeTranslate.PolicyNumber')" show-overflow-tooltip prop="policyNumberList"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showPolicyNumber(scope.row.policyNumberList)">
              <span style="font-size: 16px">{{ scope.row.policyNumberList.length }}</span>
            </el-button>
          </template>
        </el-table-column>
        <!--配置名称-->
        <el-table-column
          :label="$t('mdfeTranslate.ConfigurationName')" show-overflow-tooltip prop="configName"
          min-width="180"
        />
        <!--启用状态-->
        <el-table-column :label="$t('GlobalSetObj.EnableStatus')" min-width="120" align="center">
          <template slot-scope="scope">
            <div>
              <el-tag v-if="scope.row.state === 0" type="danger">{{ $t('GlobalSetObj.disable') }}</el-tag>
              <el-tag v-if="scope.row.state === 1" type="success">{{ $t('collectionCenter.enable') }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <!--生效时间-->
        <el-table-column
          :label="$t('customerManagements.genterTiem')" prop="effectiveTime" min-width="180"
          align="center"
        />
        <!--生效状态-->
        <el-table-column :label="$t('basicData.EffectiveStatus')" min-width="180" align="center">
          <template slot-scope="scope">
            <div>
              <!--已过期-->
              <el-tag v-if="scope.row.expirationState === 3" type="danger">{{ $t('basicData.Expired') }}</el-tag>
              <!--待生效-->
              <el-tag v-if="scope.row.expirationState === 2" type="waring">{{ $t('mdfeTranslate.Pending') }}</el-tag>
              <!--生效中-->
              <el-tag v-if="scope.row.expirationState === 1" type="success">{{ $t('mdfeTranslate.InEffect') }}</el-tag>
              <!--未生效-->
              <el-tag v-if="scope.row.expirationState === 4" type="info">{{ $t('mdfeTranslate.NotEffective') }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <!-- 备注 -->
        <el-table-column
          :label="$t('collectionCenter.Note')" show-overflow-tooltip prop="remark"
          min-width="200"
        />
        <!--配置ID-->
        <el-table-column
          :label="$t('mdfeTranslate.ConfigurationID')" prop="id" min-width="100"
          align="center"
        />
        <!--创建人-->
        <el-table-column
          :label="$t('collectionCenter.creator')" prop="createUserStr" min-width="160"
          align="center"
        />
        <!--创建时间-->
        <el-table-column
          :label="$t('collectionCenter.CreationTime')" prop="createTime" min-width="180"
          align="center"
        />
        <!--最后修改人-->
        <el-table-column
          :label="$t('basicData.LastModifier')" prop="updateUserStr" min-width="160"
          align="center"
        />
        <!--最后修改时间-->
        <el-table-column
          :label="$t('basicData.LastModified')" prop="updateTime" min-width="180"
          align="center"
        />
        <el-table-column
          :label="$t('collectionCenter.operation')"
          align="center"
          fixed="right"
          width="180"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.state === 0" type="text" size="small"
              @click="editStatus(scope.row)"
            >
              {{ $t('collectionCenter.enable') }}
            </el-button>
            <el-button
              v-if="scope.row.state === 1" type="text" size="small"
              @click="editStatus(scope.row)"
            >
              {{ $t('GlobalSetObj.disable') }}
            </el-button>
            <el-button type="text" size="small" @click="addConfiguration(2, scope.row)">
              {{ $t('GlobalSetObj.edit') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="right">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="currentChange"
          @size-change="sizeChange"
        />
      </div>
    </el-card>
    <el-drawer
      :close-on-click-modal="true"
      :destroy-on-close="true"
      :title="editType === 1 ? $t('GlobalSetObj.create') : $t('GlobalSetObj.edit')"
      :visible.sync="editConfigurationVisible"
      class="drawerClass"
      direction="ltr"
      size="80%"
    >
      <add-edit
        :key="editConfigurationKey" :row-data="rowData" :edit-type="editType"
        @closeWindow="closeWindow"
      />
    </el-drawer>
    <el-dialog
      :title="$t('mdfeTranslate.PolicyNumber')"
      :visible.sync="policyNumberVisible"
      width="600px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      top="5%"
    >
      <el-table
        :data="policyNumberData"
        border
        :header-cell-style="{background: '#e1e1e1', color: '#000', 'font-size': '15px'}"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')" align="center" type="index"
          width="80"
        />
        <el-table-column :label="$t('mdfeTranslate.PolicyType')" prop="type" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">{{ $t('mdfeTranslate.Accident') }}</span>
            <span v-if="scope.row.type === 2">{{ $t('mdfeTranslate.TheftOfGoods') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('mdfeTranslate.PolicyNumber')" prop="number" align="center" />
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
// import dayjs from 'dayjs';
import { getUserPage } from '@/api/user';
import addEdit from './addEdit.vue';
import { getInsuranceServicePage, insuranceServiceUpdateCheck, insuranceServiceUpdateConfirm } from '@/api/invoiceCenter';
import { getUserName } from '@/utils/asyncTools';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
// const beginTime = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
// const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59'; // 设置此刻的时间
export default {
  name: 'InsuranceServiceConfiguration',
  components: {
    addEdit
  },
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          name: null,
          state: null,
          beginTime: null,
          endTime: null,
          createUser: null,
          nameType: 1,
          timeType: 1
        }
      },
      total: 0,
      dateTime: [],
      tableData: [],
      allUserList: [],
      editType: 1,
      rowData: null,
      editConfigurationVisible: false,
      editConfigurationKey: new Date().getTime(),
      userIdAndNameObj: null,
      policyNumberVisible: false,
      policyNumberData: []
    };
  },
  created() {
    this.userIdAndNameObj = getUserIdAndNameObj();
    this.getAllUser();
    this.queryTableData();
  },
  methods: {
    // 点击查看保单
    showPolicyNumber(data) {
      this.policyNumberData = data;
      this.policyNumberVisible = true;
    },
    // 关闭新建窗口
    closeWindow(type) {
      if (type === 2) {
        this.getTableData();
      }
      this.editConfigurationVisible = false;
    },
    // 获取创建人
    getAllUser(name = '') {
      const query = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          accountState: '',
          realName: name
        }
      };
      getUserPage(query, false).then((res) => {
        if (res.code === 200) {
          this.allUserList = res.data.records;
        }
      });
    },
    // 打开创建人选择框
    openCreateUserSelect(val) {
      if (val) {
        this.getAllUser();
      }
    },
    // 搜索
    queryTableData() {
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 重置
    resetForm() {
      this.queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          name: null,
          state: null,
          beginTime: null,
          endTime: null,
          createUser: null,
          nameType: 1,
          timeType: 1
        }
      };
      this.dateTime = [];
      this.getTableData();
    },
    // 获取列表数据
    getTableData() {
      const query = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {
          name: this.queryForm.params.name,
          state: this.queryForm.params.state,
          beginTime: null,
          endTime: null,
          createUser: this.queryForm.params.createUser,
          nameType: this.queryForm.params.nameType,
          timeType: this.queryForm.params.timeType
        }
      };
      if (Array.isArray(this.dateTime) && this.dateTime.length === 2) {
        query.params.beginTime = this.dateTime[0];
        query.params.endTime = this.dateTime[1];
      }
      getInsuranceServicePage(query).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.records.map(item => {
            const updateUserStr = getUserName(item.updateUser, this.userIdAndNameObj);
            const createUserStr = getUserName(item.createUser, this.userIdAndNameObj);
            item.policyNumberList = JSON.parse(item.policyNumber);
            return {
              ...item,
              updateUserStr,
              createUserStr
            };
          });
          this.total = res.data.total;
        }
      });
    },
    // 添加、编辑
    addConfiguration(type, row = null) {
      this.editType = type;
      this.rowData = {
        id: '',
        cnpj: '',
        name: '',
        configName: '',
        state: 0,
        effectiveTime: '',
        remark: '',
        policyNumberList: [
          { number: '', type: '' }
        ]
      };
      if (type === 2) {
        this.rowData = {
          id: row.id,
          cnpj: row.cnpj,
          name: row.name,
          configName: row.configName,
          state: row.state,
          effectiveTime: row.effectiveTime,
          remark: row.remark,
          policyNumberList: row.policyNumberList
        };
      }
      this.editConfigurationVisible = true;
      this.editConfigurationKey = new Date().getTime();
    },
    // 启用、禁用
    editStatus(row) {
      this.rowData = {
        id: row.id,
        cnpj: row.cnpj,
        name: row.name,
        configName: row.configName,
        state: row.state === 1 ? 0 : 1,
        effectiveTime: row.effectiveTime,
        remark: row.remark,
        policyNumberList: row.policyNumberList
      };
      insuranceServiceUpdateCheck(this.rowData).then(res => {
        if (res.code === 200) {
          if (res.msg) {
            this.$confirm(res.msg, this.$t('GlobalSetObj.tips'), {
              confirmButtonText: this.$t('GlobalSetObj.confirm'),
              cancelButtonText: this.$t('GlobalSetObj.cancel'),
              type: 'warning'
            }).then(() => {
              if (res.data === 1) {
                insuranceServiceUpdateConfirm(this.rowData).then(res => {
                  if (res.code === 200) {
                    this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                    this.getTableData();
                  }
                });
              } else {
                this.editType = 1;
                this.rowData = {
                  id: '',
                  cnpj: '',
                  name: '',
                  configName: '',
                  state: 0,
                  effectiveTime: '',
                  remark: '',
                  policyNumberList: [
                    { number: '', type: '' }
                  ]
                };
                this.editConfigurationVisible = true;
                this.editConfigurationKey = new Date().getTime();
              }
            });
          } else {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            this.getTableData();
          }
        }
      });
    },
    // 翻页
    currentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    },
    // 每页条数
    sizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableData();
    }
  }
};
</script>
<style>
.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.postcodeType-class .el-input--small .el-input__inner {
  height: 25px;
  line-height: 25px;
  border: 0;
  font-weight: bold;
  padding: 0;
}
</style>
